import * as yup from 'yup';

const entitlementShape = yup.string();

export const entitlementsSchema = yup.array().of(entitlementShape);

export const nameSchema = yup.string().required('Name is required');
export const emailSchema = yup
	.string()
	.email('Email must be a correct email')
	.required('Email is required');
export const roleSchema = yup.string().required('Role is required');
export const phoneNumberSchema = yup.string();

const newUserFormShape = {
	name: nameSchema,
	email: emailSchema,
	role: roleSchema,
	phoneNumber: phoneNumberSchema,
	entitlements: entitlementsSchema,
};

export const newUserFormSchema = yup.object(newUserFormShape);
export const newUserFormSchemaWithEntitlements = yup.object({
	...newUserFormShape,
	entitlements: yup.array().of(yup.string()),
});
